import { normalizePositiveSafeIntegerIdentifier } from "@/common/helpers/normalize-numeric-identifier";

export function vehicleRequiresBranchSelectionForV1GewaSync(v1Identifier: string | undefined): boolean {
  return v1Identifier === undefined || normalizePositiveSafeIntegerIdentifier(v1Identifier) === undefined;
}
